import InfoPageShell from "../features/info/InfoPageShell";
import TRAButton from "../design/components/primitives/TRAButton";
import { APP_NAME } from "../config/brand";
import c from "../features/profile/styles/profileClaude.module.css";
import i from "../features/info/infoPageProfile.module.css";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <InfoPageShell title="Page not found" backTo="/">
      <p className={i.lead}>This page isn&apos;t on the court — the link may be outdated or mistyped.</p>
      <div className={i.actions} style={{ marginTop: 24 }}>
        <TRAButton type="button" variant="primary" onClick={() => navigate("/")}>
          Back to {APP_NAME}
        </TRAButton>
        <TRAButton type="button" variant="outlined" onClick={() => navigate("/profile")}>
          Open profile
        </TRAButton>
      </div>
    </InfoPageShell>
  );
}
